export default {
	"2db9cae3de1545e51ce292dd1c28ce54": "Subscribe to the product detail page independently",
	"e2226b1a4170f9c1303104b265be3494": "\"Self-subscribe product details page - Purchase button.",
	"0bc2692358647d0447374ab7243fea7e": "The name of the selected payment method"
}
